<template>
    <form @submit.prevent="recoverAttempt">
        <div
                class="form-group"
        >
            <input
                    :placeholder="$t('placeholder.email')"
                    class="form-control"
                    disabled="disabled"
                    type="email"
                    v-model="recoverForm.email"
            />
        </div>

        <div
                class="form-group"
                :class="{error: $v.recoverForm.password.$error}"
        >
            <input
                    :placeholder="$t('placeholder.new_password')"
                    class="form-control"
                    :disabled="loading"
                    type="password"
                    v-model="recoverForm.password"
                    @input="$v.recoverForm.password.$touch"
            />
            <template v-if="$v.recoverForm.password.$error">
                <p
                        class="error-message"
                        v-if="!$v.recoverForm.password.required"
                >
                    {{$t('validations.required', {field: $t('fields.password')})}}
                </p>

            </template>
        </div>

        <div
                class="form-group"
                :class="{error: $v.recoverForm.password_confirmation.$error}"
        >
            <input
                    :placeholder="$t('placeholder.new_password_confirm')"
                    class="form-control"
                    :disabled="loading"
                    type="password"
                    v-model="recoverForm.password_confirmation"
                    @input="$v.recoverForm.password_confirmation.$touch"
            />
            <template v-if="$v.recoverForm.password_confirmation.$error">
                <p
                        class="error-message"
                        v-if="!$v.recoverForm.password_confirmation.required"
                >
                    {{$t('validations.required', {field: $t('fields.new_password_confirm')})}}
                </p>
                <p
                        class="error-message"
                        v-if="!$v.recoverForm.password_confirmation.sameAs"
                >
                    {{$t('validations.sameAs', {field: $t('fields.new_password_confirm')})}}
                </p>
            </template>
        </div>

        <div class="captcha-container" v-if="requiresCaptcha">
            <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="recaptchaPublicKey"
                    :loadRecaptchaScript="true"
                    :theme="'dark'"
                    @verify="recoverForm.recaptcha = $event"
                    @expire="recoverForm.recaptcha = null"
            />
            <template v-if="$v.recoverForm.recaptcha.$error">
                <p
                        class="error-message"
                        v-if="!$v.recoverForm.recaptcha.required"
                >
                    {{$t('validations.captcha')}}
                </p>
            </template>
        </div>

        <div class="messages">
            <div :key="key" v-for="(errors, key) in recoverErrors">
                <p :key="error" v-for="error in errors">
                    {{error}}
                </p>
            </div>
        </div>

        <div class="buttons">
            <button
                    class="btn submit"
                    v-if="!loading"
                    :disabled="$v.recoverForm.$invalid"
                    type="submit"
            >
                <template v-if="finishing">
                    {{$t('finish_password.buttons.finish')}}
                </template>
                <template v-else>
                    {{$t('recover_password.buttons.recover')}}
                </template>
            </button>
            <Spinner v-else/>
        </div>
    </form>
</template>

<script>
  import Spinner from "./Spinner";
  import { required, minLength, email, sameAs, requiredIf } from 'vuelidate/lib/validators';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
      components: {
          Spinner,
          VueRecaptcha,
      },
      props: {
          email: {
              type: String,
              required: true,
          },
          token: {
              required: false,
              default: null
          },
          autologin: {
              required: false,
              default: false
          },
          finishing: { //Si es finishing en vez de recuperar, estas terminando de registrarte.
              required: false,
              default: false,
          }
      },
      computed: {
          recaptchaPublicKey(){
              return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
          },
          requiresCaptcha(){
              return this.recaptchaPublicKey && this.autologin;
          }
      },
      data(){
          return {
              recoverForm: {
                  email: '',
                  password: '',
                  password_confirmation: '',
                  token: '',
                  recaptcha: null,
              },
              recoverErrors: {},
              loading: false,
          }
      },
      methods: {
          recoverAttempt(){
              if(this.$v.recoverForm.$invalid){
                  return this.$v.recoverForm.$touch();
              }

              this.loading = true;
              this.recoverErrors = [];

              this.$http.post('auth/recover', {
                  email: this.recoverForm.email,
                  password: this.recoverForm.password,
                  password_confirmation: this.recoverForm.password_confirmation,
                  token: this.recoverForm.token,
              }).then((response) => {
                      if(this.autologin){
                          this.$auth.login({
                              body: {
                                  email: this.recoverForm.email,
                                  password: this.recoverForm.password,
                                  recaptcha: this.recoverForm.recaptcha,
                              },
                              success: function (resp) {
                                  this.$emit('successfullLogin', resp);
                              },
                              error: function (resp) {
                                  this.$emit('failedLogin', resp);
                              },
                              redirect: null
                          });
                      }else{
                          this.$emit('successfullRecover', response);
                      }
                  }).catch((response) => {
                      this.loading = false;
                      this.recoverErrors = response.data.errors || {general: [this.$t('error')]};
                      this.$emit('failedRecover', response);

                      if(this.requiresCaptcha){
                          this.$refs.recaptcha.reset();
                          this.recoverForm.recaptcha = null;
                      }
                  });
          }
      },
      validations(){
          return {
              recoverForm: {
                  password: {
                      required
                  },
                  password_confirmation: {
                      required,
                      sameAsPassword: sameAs('password'),
                  },
                  recaptcha: {
                      required: requiredIf(() => this.requiresCaptcha)
                  }
              },
          }
      },
      watch: {
          email(){
              this.recoverForm.email = this.email;
          },
          token(){
              this.recoverForm.token = this.token;
          },
          loading(){
              this.$emit('loadingChange', this.loading);
          },
      }
  }
</script>

<style scoped lang="scss">
    @import '../styles/variables';
    @import '../styles/classes';

    .buttons{
        .btn.submit{
            padding: 1em;
            width: 100%;
            @extend %fresh-btn;
        }
    }
</style>
